import React from 'react'
import classes from './Place.module.sass'
import { Helmet } from 'react-helmet-async'
import { List } from './components/list/List'
import { Button } from '../../../common/components/button/Button'
import { Modal } from '../../../common/components/modal/Modal'
import { Form } from './components/form/Form'
import { Details } from './components/details/Details'
import { useSelector } from 'react-redux'
import { selectCurrentCluster } from '../../../store/slices/currentClusterSlice'
import Search from '../../../common/components/listControl/search/Search'
import { useSearchWithDebounce } from '../../../common/hooks/useSearchWithDebounce'
import { usePlace } from './usePlace'

export const Place = () => {
  const {
    getList,
    modalActive,
    setModalActive,
    startCreate,
    edit,
    startEdit,
    data,
    setData,
    list,
    detailsModalActive,
    setDetailsModalActive,
    showDetails,
    current,
    loading,
    startDuplicate,
  } = usePlace()

  const currentCluster = useSelector(selectCurrentCluster)

  const { searchQuery, handleSearch, clearSearch, filteredItems } = useSearchWithDebounce({
    items: list,
    searchFields: ['id', 'name', 'description', 'placeNumber'],
    debounceMs: 300,
  })

  return (
    <div className={classes.container}>
      <Helmet>
        <title>Управление местами</title>
        <meta name="description" content="Управление местами (столики, кассы, рабочие места)" />
      </Helmet>

      <div className={classes.titleWithButtons}>
        <div className={classes.header}>Места</div>
        <Button onClick={startCreate} text="Создать" />
      </div>

      <div className={classes.searchContainer}>
        <Search
          onChange={handleSearch}
          clear={clearSearch}
          value={searchQuery}
          placeHolder="Поиск по id, названию, описанию или номеру места"
        />
      </div>

      <List
        startEdit={startEdit}
        startDuplicate={startDuplicate}
        list={filteredItems}
        showDetails={showDetails}
        loading={loading}
      />

      <Modal modalActive={modalActive} setModalActive={setModalActive}>
        <Form
          edit={edit}
          data={data}
          setData={setData}
          getList={getList}
          setModalActive={setModalActive}
          el={current}
        />
      </Modal>

      <Modal modalActive={detailsModalActive} setModalActive={setDetailsModalActive}>
        <Details el={current} />
      </Modal>
    </div>
  )
}
